import { Periode } from "./Periods";

export class PeriodeDate {
  periode: Periode;
  startDay: number;
  startMonth: number;
  endDay: number;
  endMonth: number;

  constructor({
                periode = Periode.NOEL_NA,
                startDay = 1,
                startMonth = 12,
                endDay = 31,
                endMonth = 1
              }: Partial<PeriodeDate> = {}) {
    this.periode = periode;
    this.startDay = startDay;
    this.startMonth = startMonth;
    this.endDay = endDay;
    this.endMonth = endMonth;
  }
}

/**
 * Définit les différentes périodes
 */
export const periodeDates: PeriodeDate[] = [
  new PeriodeDate({ periode: Periode.CARNAVAL, startDay: 1, startMonth: 2, endDay: 31, endMonth: 3 }),
  new PeriodeDate({ periode: Periode.PRINTEMPS, startDay: 1, startMonth: 4, endDay: 31, endMonth: 5 }),
  new PeriodeDate({ periode: Periode.ETE, startDay: 1, startMonth: 6, endDay: 30, endMonth: 9 }),
  new PeriodeDate({ periode: Periode.TOUSSAINT, startDay: 1, startMonth: 10, endDay: 30, endMonth: 11 }),
  new PeriodeDate({ periode: Periode.NOEL_NA, startDay: 1, startMonth: 12, endDay: 31, endMonth: 1 })
];

/**
 * Vérifie si une date donnée est dans une période
 */
function isDateInPeriode(date: Date, periode: PeriodeDate): boolean {
  const month = date.getMonth() + 1; // 1 à 12
  const day = date.getDate();
  const { startMonth, startDay, endMonth, endDay } = periode;

  if (startMonth < endMonth || (startMonth === endMonth && startDay <= endDay)) {
    // période dans la même année
    return (month > startMonth || (month === startMonth && day >= startDay)) &&
      (month < endMonth || (month === endMonth && day <= endDay));
  } else {
    // période qui traverse l'année (ex: Noël)
    return (month > startMonth || (month === startMonth && day >= startDay)) ||
      (month < endMonth || (month === endMonth && day <= endDay));
  }
}

/**
 * Retourne la période correspondant à une date
 */
export function getPeriodeByDate(date: Date): PeriodeDate | undefined {
  return periodeDates.find(periode => isDateInPeriode(date, periode));
}

/**
 * Retourne la période courante et les 3 suivantes
 */
export function getCurrentAndNextPeriode(date: Date): PeriodeDate[] {
  return [...periodeDates];
}
/**
 * Retourne un objet PeriodeDate sur base du nom
 */
export function getPeriodeByName(periodeName: string): PeriodeDate {
  const periodeEnumValues = Object.values(Periode);
  const periode = periodeEnumValues.find(value => value.toString() === periodeName);
  return periodeDates.find(date => date.periode === periode)!;
}
